import { isOldFormatSalesforceId as isOldFormatId } from 'shared/utils/queryAnalysis';

export class ObjectsCache {
  constructor() {
    this.objectsMap = new Map();
    this.idsReplacements = new Map(); // To replace 15-digits ids with 18-digits
  }

  add(objectName, id, object) {
    const fmtObjectName = this.format(objectName);
    const objectsData = this.objectsMap.get(fmtObjectName);
    const idsMap = objectsData ?? new Map();
    const trueId = this.getTrueId(id);

    let objectForCaching = object;
    const cachedObject = idsMap.get(trueId);
    if (cachedObject) {
      // To add new fields
      objectForCaching = {
        ...cachedObject,
        ...object
      }
    }
    idsMap.set(trueId, objectForCaching);

    if (!objectsData) {
      this.objectsMap.set(fmtObjectName, idsMap); 
    }
  }

  getById(id) {
    const trueId = this.getTrueId(id);
    for (const [objectName, idsMap] of this.objectsMap.entries()) {
      const object = idsMap.get(trueId);
      if (object) {
        return { object, objectName };
      }
    }
    return null;
  }

  getByObjectName(objectName) {
    const fmtObjectName = this.format(objectName);
    const idsMap = this.objectsMap.get(fmtObjectName);
    return idsMap ? Array.from(idsMap.values()) : [];
  }

  addIdReplacement(id15, id18) {
    if (isOldFormatId(id15)) {
      // Do not format id18, since we would like to get it in this.getIdReplacement
      // in the same format as an user provides it here
      this.idsReplacements.set(this.format(id15), id18);
    }
  }

  getIdReplacement(id) {
    const fmtId = this.format(id);
    return isOldFormatId(fmtId)
      ? this.idsReplacements.get(fmtId) ?? id
      : id;
  }

  format(value) {
    return value.toLowerCase();
  }

  getTrueId(id) {
    return this.format(this.getIdReplacement(id));
  }
};


export default ObjectsCache;